<script>
	import moment from 'moment';
	export let bg = "reviews_bg.png";
	export let reviewcode;
	export let reviewrname;
	export let reviewdate;
	export let description;
	export let ratingnumber;
</script>

<div class="home-carousel">
	<div class="room-item room2-carousel ">
	   <div class="home_reviews_min_ht" style="background: url('../images/{bg}')">&nbsp;</div>
	   <div class="room-content-wrapper">
		  <span class="overlay"></span>
		  <div class="room-title">
			 <h5>{reviewrname}</h5>
			 <span class="review_date">( {reviewcode} ) </span>&nbsp; - &nbsp;
			 <span class="review_date"> {moment(reviewdate).fromNow()}  </span>
		  </div>
		  <div class="room-excerpt">
			 <p>{description}</p>
		  </div>
		  <div class="room-price-wrapper">
			 <div class="room-price style-2">
				<span class="inline-price">
				   <div class="rating_bar">
					  <div class="rating" style="width: {ratingnumber * 20}%;"></div>
				   </div>
				</span>
			 </div>
		  </div>
	   </div>
	</div>
 </div>
<style>
    .room-item {
		position: relative;
	}

    .room-item {
		position: relative;
	}

	.room-content-wrapper {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		padding: 30px;
	}

	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(15,36,83,.4);
		transition: all .3s ease;
	}

	.room-title {
		top: 40%;
		position: relative;
		text-align: center;
		display: block;
		transition: all .3s ease;
	}

	.room-excerpt {
		position: relative;
		top: 22%;
		opacity: 0;
		-webkit-transition: opacity .3s ease;
		-moz-transition: opacity .3s ease;
		-ms-transition: opacity .3s ease;
		-o-transition: opacity .3s ease;
		transition: opacity .3s ease;
	}

	.room-price-wrapper {
		position: absolute;
		bottom: 45px;
		text-align: center;
		left: 80px;
		right: 80px;
	}

	.room-item .room-excerpt {
		top: 0;
	}

	.room-item .room-content-wrapper:hover .room-excerpt {
		opacity: 1;
	}

	.room-item .room-content-wrapper:hover .room-title {
		top: 0;
	}

	.room-content-wrapper:hover .overlay {
		background-color: rgba(150,122,80,0.7);
	}

	.room-excerpt p {
		color: #fff;
		text-align: justify;
	}

	.room-price {
		background-color: #967a50;
		color: #ffffff;
		letter-spacing: .1rem;
		padding: 14px 36px;
		text-transform: uppercase;
		font-family: Lato;
		font-weight: 500;
		font-size: 1.125rem;
		-webkit-transition: all .3s ease;
		-moz-transition: all .3s ease;
		-ms-transition: all .3s ease;
		-o-transition: all .3s ease;
		transition: all .3s ease;
		border-radius: 6px;
	}

    .room2-carousel {
        width: 463px;
    }

    .home_reviews_min_ht {
		min-height: 450px;
	}

	.room2-carousel .room-content-wrapper {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		padding: 30px;
	}

	.room2-carousel .room-content-wrapper .overlay {
		background-color: rgba(15,36,83,0.4);
	}

	.room2-carousel .room-content-wrapper .overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(15,36,83,.4);
		transition: all .3s ease;
	}

    .room2-carousel .room-title {
        top: 40%;
        position: relative;
        text-align: center;
        display: block;
        transition: all .3s ease;
    }
    
    .home-carousel .room-title {
        top: 0 !important;
    }

    .home-carousel .room-item .room-title h5 {
        color: #fff;
    }

    .home-carousel .room-excerpt {
        opacity: 1;
        top: 5px;
    }
    .room2-carousel .room-excerpt {
        top: 0;
    }
    .room2-carousel .room-excerpt {
        position: relative;
        top: 22%;
        opacity: 0;
        -webkit-transition: opacity .3s ease;
        -moz-transition: opacity .3s ease;
        -ms-transition: opacity .3s ease;
        -o-transition: opacity .3s ease;
        transition: opacity .3s ease;
    }

    .room2-carousel .room-price-wrapper {
        position: absolute;
        bottom: 45px;
        text-align: center;
        left: 0;
        right: 0;
    }

    .room2-carousel .room-content-wrapper:hover .overlay {
        background-color: rgba(150,122,80,0.7);
    }

    .review_date {
        color: #fff;
    }

    .home-carousel .room-excerpt {
        opacity: 1;
        top: 5px;
    }

    .home-carousel .room-price-wrapper {
        position: absolute;
        bottom: 45px;
        text-align: center;
        width: 156px;
        left: 50%;
        transform: translate(-50%);
    }

    .rating {
        background: rgba(0, 0, 0, 0) url("../images/stars.png") repeat-x scroll 0 -16px;
        height: 16px;
        text-align: center;
    }

    .rating_bar {
        background: rgba(0, 0, 0, 0) url("../images/stars.png") repeat-x scroll 0 0;
        text-align: left;
        width: 80px;
        max-width: 100%;
    }

	@media only screen and (min-width: 320px) and (max-width: 650px) {
		:global(.reviews-page .home-carousel) {
			width: 100%;
		}

		:global(.reviews-page .home-carousel .room2-carousel) {
			width: 100%;
		}
	}
</style>